import React, {useEffect, useState} from "react";
import IranFlag from "../../assets/images/iran.webp";
import moment from 'moment-jalaali';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@material-ui/core/IconButton';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import EditIcon from '@material-ui/icons/Edit';
import PrintIcon from '@mui/icons-material/Print';
import api from "../../api";
import "../../css/global.css";
import {e2p} from "../../utils/utils";
import {toast} from "react-toastify";
import LoadingSpinner from "../Loading";

function Report({reportsData}) {
    const [reports, setReports] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    
    async function handlePrintDetails(reportId) {
        try {
            const response = await api.get(`/repair-request/print-repair-items/${reportId}`, {
                responseType: 'blob',
            });
            
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `repair_items_${reportId}.pdf`);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error(error);
        }
    }
    
    async function handlePrintInsurance(reportId) {
        try {
            const response = await api.get(`/repair-request/print-insurance/${reportId}`, {
                responseType: 'blob'
            });
            
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `insurance_${reportId}.pdf`);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error(error);
        }
    }
    
    async function handlePrintContract(reportId) {
        try {
            const response = await api.get(`/repair-request/print-contract/${reportId}`, {
                responseType: 'blob',
            });
            
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `contract_${reportId}.pdf`);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error(error);
        }
    }
    
    useEffect(() => {
        setReports([]);
        const fetchReports = async () => {
            try {
                if (reportsData.length > 0) {
                    const results = await Promise.all(
                        reportsData.map(async (report) => {
                            report['createdAt'] = moment(report.created_at)
                                .locale('fa')
                                .format('jYYYY/jMM/jDD HH:mm');
                            let SmoothingCost = 0;
                            let SmoothingDuration = 0;
                            let PaintingCost = 0;
                            let PaintingDuration = 0;
                            
                            if (report.repair_items.length > 0)
                                report.repair_items.map((repairItem) => {
                                    if (repairItem.type === '1') {
                                        SmoothingCost += repairItem.full_price;
                                        SmoothingDuration += repairItem.duration;
                                    } else {
                                        PaintingCost += repairItem.full_price;
                                        PaintingDuration += repairItem.duration;
                                    }
                                });
                            report['SmoothingCost'] = SmoothingCost;
                            report['SmoothingDuration'] = SmoothingDuration;
                            report['PaintingCost'] = PaintingCost;
                            report['PaintingDuration'] = PaintingDuration;
                            let ExtraToolsCost = 0;
                            if (report.extra_tools.length > 0)
                                report.extra_tools.map((extraTool) => {
                                    ExtraToolsCost += extraTool.price;
                                });
                            let PaymentsPrices = 0
                            if (report.payments.length > 0)
                                report.payments.map((payment) => {
                                    PaymentsPrices += payment.amount;
                                });
                            report['ExtraToolsCost'] = ExtraToolsCost;
                            report['PaymentsPrices'] = PaymentsPrices;
                            const fullCost = report.ExtraToolsCost + report.PaintingCost + report.SmoothingCost
                            const discountedCost = fullCost - report.discount
                            report['remainedCost'] = discountedCost - report.PaymentsPrices
                            report['carOwner'] = report.car.car_owner
                            let smoother = ''
                            let painter = ''
                            report.worker_repair_request.map(worker => {
                                if (worker.type === "1") {
                                    smoother = worker.worker.name
                                } else {
                                    painter = worker.worker.name
                                }
                            })
                            report['Smoother'] = smoother
                            report['Painter'] = painter
                            return report;
                        })
                    );
                    setReports(results);
                }
            } catch (error) {
                toast.error('خطا در بارگیری اطلاعات');
            } finally {
                setIsLoaded(true);
            }
        };
        fetchReports();
    }, [reportsData]);
    
    return (
        <div className="row">
            {isLoaded ? (
                <>
                    {
                        reports.map(report => (
                            <div className="col-12">
                                <div className="card shadow rounded-3 mb-2 border-3 border-dark">
                                    <div className="card-header text-center p-0">
                                        {report.status === 4 ? (
                                            <div className="text-center bg-dark">
                                                <IconButton color="inherit" disabled={true}>
                                                    <h6 className="text-white">ترخیص شده</h6>
                                                </IconButton>
                                                <IconButton href="#" onClick={() => handlePrintInsurance(report.id)}>
                                                    <PrintIcon titleAccess="پرینت بیمه"/>
                                                    <h6 className="text-white">پرینت بیمه</h6>
                                                </IconButton>
                                                <IconButton href="#" onClick={() => handlePrintDetails(report.id)}>
                                                    <PrintIcon titleAccess="پرینت کارتکس"/>
                                                    <h6 className="text-white">پرینت کارتکس</h6>
                                                </IconButton>
                                                <IconButton href="#" onClick={() => handlePrintContract(report.id)}>
                                                    <PrintIcon titleAccess="پرینت قرارداد"/>
                                                    <h6 className="text-white">پرینت قرارداد</h6>
                                                </IconButton>
                                            </div>
                                        ) : (
                                            <div className="text-center bg-dark">
                                                <IconButton href={`/request/${report.id}/release/${report.car.id}`}>
                                                    <DriveEtaIcon sx={{color: 'icon.color'}} titleAccess="ترخیص خودرو"/>
                                                    <h6 className="text-white">ترخیص</h6>
                                                </IconButton>
                                                <IconButton href={`/request/${report.id}/edit/${report.car.id}`}>
                                                    <EditIcon titleAccess="ویرایش"/>
                                                    <h6 className="text-white">ویرایش</h6>
                                                </IconButton>
                                                <IconButton href="#" onClick={() => handlePrintInsurance(report.id)}>
                                                    <PrintIcon titleAccess="پرینت بیمه"/>
                                                    <h6 className="text-white">پرینت بیمه</h6>
                                                </IconButton>
                                                <IconButton href="#" onClick={() => handlePrintDetails(report.id)}>
                                                    <PrintIcon titleAccess="پرینت کارتکس"/>
                                                    <h6 className="text-white">پرینت کارتکس</h6>
                                                </IconButton>
                                                <IconButton href="#" onClick={() => handlePrintContract(report.id)}>
                                                    <PrintIcon titleAccess="پرینت قرارداد"/>
                                                    <h6 className="text-white">پرینت قرارداد</h6>
                                                </IconButton>
                                            </div>
                                        )}
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-1">
                                            <div className="col-lg-4 col-md-6 col-sm-12">
                                                <div className="card border-1 p-2 h-100 justify-content-between">
                                                    <div className="card shadow position-relative mb-2 h-auto"
                                                         style={{minHeight: '15rem'}}>
                                                        <a href={`/album/${report.id}`}>
                                                            {report.albums[0] ? (
                                                                <img className="img-fluid rounded-2"
                                                                     src={report.albums[0].url}
                                                                     style={{minHeight: '15rem'}}
                                                                     alt="carImage"/>
                                                            ) : (
                                                                <div className="text-center">
                                                                    {report.status !== 4 &&
                                                                        <div className="text-center">
                                                                            <AddIcon fontSize="3rem"
                                                                                     className="mx-auto"/>
                                                                            افزودن تصویر
                                                                        </div>
                                                                    }
                                                                </div>
                                                            )}
                                                        </a>
                                                    </div>
                                                    <div className="row pelak g-0 mb-2">
                                                        <div className="col">
                                                            <div className="row g-0">
                                                                <div className="col border-start">
                                                                    <p className="text-center m-0 fw-bold iranNo">ایران</p>
                                                                    <div>
                                                                        <p className="border-0 text-center">{report.car.plate.slice(7, 9)}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="col">
                                                                    <p className="border-0 text-center mt-3">{report.car.plate.slice(3, 6)}</p>
                                                                </div>
                                                                <div className="col">
                                                                    <p className="border-0 text-center mt-3">{report.car.plate.slice(2, 3)}</p>
                                                                </div>
                                                                <div className="col">
                                                                    <p className="border-0 text-center mt-3">{report.car.plate.slice(0, 2)}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-auto leftSide">
                                                            <div className="flag">
                                                                <img src={IranFlag} alt="iran's flag"/>
                                                            </div>
                                                            <div className="iranText text-center">
                                                                <p>I.R.</p>
                                                                <p>IRAN</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="car-name mb-2">
                                                        {report.car.model_name} <small
                                                        className="text-black-50">[{report.car.color}]</small>
                                                    </div>
                                                    <div className="date-p mb-2">
                                                        {e2p(report.createdAt.toString()).replace(' ', ' - ')}
                                                    </div>
                                                    <div className="d-grid gap-2">
                                                        وضعیت: {report.status === 1 ? 'پذیرش شده' : report.status === 2 ? 'نوبت دهی شده' : report.status === 3 ? 'انصراف داده' : report.status === 4 ? 'ترخیص شده' : report.status === 5 ? 'نقاشی' : ''}
                                                        {report.status !== 4 &&
                                                            <input
                                                                type="submit"
                                                                className="status btn btn-primary"
                                                                name="submit"
                                                                value="تغییر وضعیت"
                                                                onClick={() => {
                                                                    window.location.href = `/car/${report.car.id}/status/${report.id}`
                                                                }}
                                                            />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-8 col-md-6 col-sm-12">
                                                <div className="card border-1 p-2 h-100 justify-content-between p-3">
                                                    <table className="table table-border-bottom-0">
                                                        <tbody>
                                                        <tr>
                                                            <td>
                                                                <small className="text-warning">شماره پذیرش:</small>
                                                            </td>
                                                            <td>
                                                                {e2p((report.tracking_code ?? report.id).toString())}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <small
                                                                    className="text-warning">تلفن:</small>
                                                            </td>
                                                            <td>
                                                                {e2p(report.carOwner.mobile_number)}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <small
                                                                    className="text-warning">مالک:</small>
                                                            </td>
                                                            <td>
                                                                {report.carOwner.name} {report.carOwner.lastname}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <small
                                                                    className="text-warning">کیلومتر:</small>
                                                            </td>
                                                            <td>
                                                                {e2p(report.kilometerage.toLocaleString())}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <small className="text-warning">میزان
                                                                    سوخت:</small>
                                                            </td>
                                                            <td>
                                                                {report.amount_of_fuel}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <small className="text-warning">هزینه
                                                                    صافکاری: </small>
                                                            </td>
                                                            <td>
                                                                {e2p(report.SmoothingCost?.toLocaleString()) ?? ''} تومان
                                                                ({e2p(report.SmoothingDuration.toString())} روز)
                                                                {report.status !== 4 &&
                                                                    <a href={`/car/${report.car.id}/smoothing/${report.id}`}>
                                                        <span className="float-start">
                                                            <AddIcon/>
                                                        </span>
                                                                    </a>
                                                                }
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <small className="text-warning">هزینه
                                                                    نقاشی:</small>
                                                            </td>
                                                            <td>
                                                                {e2p(report.PaintingCost?.toLocaleString()) ?? ''} تومان
                                                                ({e2p(report.PaintingDuration.toString())} روز)
                                                                {report.status !== 4 &&
                                                                    <a href={`/car/${report.car.id}/painting/${report.id}`}>
                                                        <span className="float-start">
                                                            <AddIcon/>
                                                        </span>
                                                                    </a>
                                                                }
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <small className="text-warning">نقاش: </small>
                                                            </td>
                                                            <td>
                                                                {report.Painter}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <small className="text-warning">صافکار:</small>
                                                            </td>
                                                            <td>
                                                                {report.Smoother}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <small className="text-warning">مبلغ
                                                                    لوازم:</small>
                                                            </td>
                                                            <td>
                                                                {e2p(report.ExtraToolsCost?.toLocaleString()) ?? ''} تومان
                                                                {report.status !== 4 &&
                                                                    <a href={`/request/${report.id}/extra-tool/${report.car.id}`}>
                                                        <span className="float-start">
                                                            <AddIcon/>
                                                        </span>
                                                                    </a>
                                                                }
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <small className="text-warning">مبلغ
                                                                    پرداختی:</small>
                                                            </td>
                                                            <td>
                                                                {e2p(report.PaymentsPrices?.toLocaleString()) ?? ''} تومان
                                                                {report.status !== 4 &&
                                                                    <a href={`/request/${report.id}/payment/${report.car.id}`}>
                                                        <span className="float-start">
                                                            <AddIcon/>
                                                        </span>
                                                                    </a>
                                                                }
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <small
                                                                    className="text-warning"> تخفیف:</small>
                                                            </td>
                                                            <td>
                                                                {e2p(report.discount?.toLocaleString()) ?? ''} تومان
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <small className="text-warning">مانده
                                                                    حساب:</small>
                                                            </td>
                                                            <td>
                                                                {e2p(report.remainedCost?.toLocaleString()) ?? ''} تومان
                                                            </td>
                                                        </tr>
                                                        <tr className="border-bottom-0">
                                                            <td>
                                                                <small className="text-warning">
                                                                    توضیحات:</small>
                                                            </td>
                                                            <td>
                                                                {report.description}
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </>
            ) : (
                <LoadingSpinner/>
            )}
        
        </div>
    )
}

export default Report;
